import { colors } from "@mui/material";

export const SeverityColors = {
	critical: colors.red.A400,
	low: colors.green[800],
	info: colors.blue.A200,
	high: colors.orange.A400,
	medium: colors.yellow.A400,
}

export const EntityColors = {
	domains: colors.green[800],
	ips: colors.blue[800],
	ports: colors.cyan[800],
	technologies: colors.grey[800],
	certificates: colors.purple[800],
	weaknesses: colors.orange[800],
	vulnerabilities: colors.red[800],
}
